export default __webpack_public_path__ + "static/media/recbin.0d444f9a.svg";